import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { usePermanentRealTimeUser } from "hooks";
import { createFormHelper } from "lib/Form";
import { isAdmin } from "utils/common";

import type { LocationAdminFormPayload } from "modules/DealerLocationDetails";

const FormHelper = createFormHelper<LocationAdminFormPayload>();

type CustomerCommunicationProps = {
  tabId: string;
};

export const CustomerCommunication = ({ tabId }: CustomerCommunicationProps) => {
  const { t } = useTranslation();

  const { user } = usePermanentRealTimeUser();

  if (!user || !isAdmin(user.role_id)) return null;

  return (
    <Element name={tabId} className="dealer-location-section">
      <div className="section-title">
        <div>
          <Icon className="comments" />
        </div>
        <span className="section-title-text">{t("v8_customer_communication", "Customer Communication")}</span>
      </div>

      <div className="dealer-location-subheading">{t("v8_customer_communication_settings", "Customer Communication Settings")}</div>
      <div className="dealer-location-columns">
        <div className="dealer-location-column">
          <Form.Field>
            <FormHelper.Field.Checkbox name="third_party_send_communications" label={t("v8_third_party_send_communications", "Third party send communications")} />
          </Form.Field>
          <Form.Field>
            <FormHelper.Field.Checkbox name="online_check_in_enabled" label={t("v8_online_check_in_communication", "Online Check-in Communication")} />
          </Form.Field>
          <Form.Field>
            <FormHelper.Field.Checkbox name="desk_check_in_enabled" label={t("v8_desk_check_in", "Desk Check-in")} />
          </Form.Field>
          <Form.Field>
            <FormHelper.Field.Checkbox
              name="is_open_desk_checkout_on_car_out_of_shop_enabled"
              label={t("v8_show_desk_checkout_on_car_out_of_shop", "Show desk check-out on car out of shop")}
            />
          </Form.Field>
          <Form.Field>
            <FormHelper.Field.Checkbox
              name="car_out_of_shop_at_desk_checkout_enabled"
              label={t("v8_put_car_out_of_shop_after_desk_check_out", "Put car out of shop after desk check-out")}
            />
          </Form.Field>
        </div>

        <div className="dealer-location-column">
          <Form.Field>
            <FormHelper.Field.Checkbox name="diagnose_overview_enabled" label={t("v8_diagnose_overview", "Diagnose overview")} />
          </Form.Field>
          <Form.Field>
            <FormHelper.Field.Checkbox name="repair_overview_enabled" label={t("v8_repair_overview", "Repair overview")} />
          </Form.Field>
          <Form.Field>
            <FormHelper.Field.Checkbox name="is_keylocker_enabled" label={t("v8_keylocker", "Keylocker")} />
          </Form.Field>
          <Form.Field>
            <FormHelper.Field.Checkbox name="is_kiosk_enabled" label={t("v8_kiosk", "Kiosk")} />
          </Form.Field>
        </div>
      </div>
    </Element>
  );
};
